<template>
  <v-dialog scrollable max-width="1600" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-row align="center" justify="center">
        <v-btn color="info" v-on="on" @click="iniciar">Agregar</v-btn>
      </v-row>
    </template>
    <v-card v-if="loading" max-width="1600" max-height="80%">
      <v-card-title>
        <h4 v-if="loading">cargando . . .</h4>
      </v-card-title>
    </v-card>
    <v-card>
      <v-tabs v-if="!loading" v-model="tab" align-tabs="center" color="deep-purple-accent-4">
        <v-tab>INDIVIDUAL</v-tab>
        <v-tab>MASIVO V3</v-tab>
      </v-tabs>
      <v-window v-model="tab" v-if="!loading">
        <v-window-item :value="0">
          <v-container fluid id="scroll-target" class="overflow-y-auto" style="max-height: 600px; max-width=100%">
            <v-row>
              <v-col cols="12" md="12">

                <v-card max-width="1600" height="80%" v-if="pendientes && !loading">
                  <v-card-title>
                    <h4>Agregar detalle de pago</h4>
                  </v-card-title>
                  <v-card-text>

                    <v-container id="scroll-target" class="overflow-y-auto " style="max-width: 1500px">
                      <v-text-field type=text label="Nombre" :value="busqueda" v-on:keyup="buscar" autofocus />

                      <v-data-table dense :items="filtrado" :headers="headers" :items-per-page="5">
                        <template v-slot:[`item.monto`]="props">
                          {{ props.item.monto | numberFormat }}
                        </template>

                        <template v-slot:[`item.montoFactura`]="props">
                          <div v-if="props.item.montoFactura">
                            {{ props.item.montoFactura | numberFormat }}
                          </div>
                        </template>
                        <template v-slot:[`item.actions`]="props">
                          <v-btn small v-if="props" @click="confirmar(props.item)">Seleccionar</v-btn>
                        </template>

                      </v-data-table>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn color="info" @click="volver">Volver</v-btn>
                    <v-btn color="info" @click="actualizar">Actualizar lista de Pagos</v-btn>
                    <!-- <v-btn color="info" @click="confirmarMasivo">MASIVO</v-btn> -->
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-window-item>
        <v-window-item :value="1">
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <GeneracionAutocomplete :filtroEstado="['Cerrado']" @generacionId="setGeneracionId" />
              </v-col>
              <!-- <v-col cols="6">
                <v-select v-model="selectedMedioPago" :hint="`${selectedMedioPago.str}`" :items="itemsMedioPago"
                  item-text="nombre" item-value="str" label="Seleccione una forma de pago" persistent-hint return-object
                  single-line></v-select>
              </v-col> -->
              <v-col cols="6">
                <v-row dense class="ml-1" style="font-size: 0.8rem; line-height: 1;">
                  <v-col v-for="mp in selectedMedioPago" :key="mp.id" cols="6" class="py-0">
                    <span>{{ mp.nombre }}</span>
                    <span>{{ mp.str }}</span>
                  </v-col> 
                </v-row>
              </v-col>
              <v-col cols="6">

                <v-radio-group v-model="selectedOrigen" :mandatory="true" row>
                  <v-radio label="TRANSFERENCIA SIPAP" value="SIPAP"></v-radio>
                  <v-radio label="BILLETERA ZIMPLE" value="ZIMPLE"></v-radio>
                </v-radio-group>

              </v-col>

            </v-row>
            <v-row>
              <v-col cols="6">
                <v-checkbox v-model="selectedMemType" label="ACTIVO" value="SA" hide-details></v-checkbox>
                <v-checkbox v-model="selectedMemType" label="ADMINISTRADO" value="AD" hide-details></v-checkbox>
                <v-checkbox v-model="selectedMemType" label="REPRESENTADO" value="RE" hide-details></v-checkbox>
                <v-checkbox v-model="selectedMemType" label="HEREDERO" value="HER" hide-details></v-checkbox>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <v-col cols="6">
                    <v-text-field type=number label="Monto minimo" v-model="selectedMontoMinimo" />
                    Gs. {{ selectedMontoMinimo | numberFormat }}
                  </v-col>
                  <v-col cols="6">
                    <v-text-field type=number label="Monto maximo" v-model="selectedMontoMaximo" />
                    Gs. {{ selectedMontoMaximo | numberFormat }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="ma-2 green--text" v-if="busquedaMasivaRealizada">
              <h3 class="text-green">Se encontraron {{ filtrado.length }} registros</h3>
            </v-row>
            <v-row align="center" justify="center" class="pa-2">
              <v-btn class="ml-4" color="primary" @click="showDialog = false">VOLVER</v-btn>
              <v-btn class="mx-2" color="primary" @click="buscarMasivo" :disabled="!btnBuscarMasivo">BUSCAR</v-btn>
              <v-btn color="primary" @click="confirmarMasivo" :disabled="!busquedaMasivaRealizada">PROCESAR</v-btn>
            </v-row>
          </v-container>
        </v-window-item>
      </v-window>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import axios from "axios";
import numeral from "numeral";
// import regexParser from "regex-parser";
// import "numeral/locales/es"
import GeneracionAutocomplete from "@/components/shared/GeneracionAutocomplete.vue";


export default Vue.extend({
  components: {
    GeneracionAutocomplete
  },
  props: ["medioPagoId"],
  data() {
    return {
      busquedaMasivaRealizada: false,
      selectedOrigen: null,
      selectedMontoMaximo: '',
      selectedMontoMinimo: '0',
      selectedMedioPago: [],
      selectedMemType: [],
      selectedGeneracionId: null,
      tab: null,
      loading: false,
      showDialog: false,
      descripcion: "",
      busqueda: "",
      buscarTimer: null,
      pendientes: [],
      filtrado: [],
      rules: {
        required: value => !!value || "Requerido.",
        counter: value => value.length <= 1000 || "Maximo 100 caracteres"
      },
      validForm: false,
      headers: [
        { text: "Generación", value: "nombreCorto" },
        { text: "Orden Pago", align: "end", value: "ordenPagoId" },
        { text: "Forma Cobro", value: "nombreBanco" },
        { text: "MemType", value: "memType" },
        { text: "CodMemSq", value: "codMemSq" },
        { text: "Cedula Titular", value: "cedulaTitular" },
        { text: "Nombre Titular", value: "nombreTitular" },
        { text: "N Cuenta", value: "numeroCuenta" },
        { text: "Monto", align: "end", value: "monto" },
        { text: "", value: "actions" },
      ],
    };
  },
  mounted() {
    if (!numeral.locale) {
      numeral.register("locale", "es", {
        delimiters: {
          thousands: ".",
          decimal: ",",
        },
        currency: {
          symbol: "GPY",
        },
      });

      numeral.locale("es");
    }

  },
  watch: {
    selectedOrigen: function (newVal) {

      if (newVal === 'ZIMPLE') {
        this.selectedMedioPago = [
          { nombre: 'ZIMPLE', id: 25 },
        ]
      } else if (newVal === 'SIPAP') {
        this.selectedMedioPago = [
          { nombre: 'BANCO NACIONAL DE FOMENTO', id: 1 },
          { nombre: 'BANCO FAMILIAR', id: 2 },
          { nombre: 'BANCO ATLAS', id: 3 },
          { nombre: 'BANCO GNB', id: 4 },
          { nombre: 'BNF', id: 5 },
          { nombre: 'CITIBANK', id: 6 },
          { nombre: 'BANCOP', id: 7 },
          { nombre: 'BANCO INTERFISA', id: 9 },
          { nombre: 'ITAU', id: 14 },
          { nombre: 'CONTINENTAL', id: 15 },
          { nombre: 'SUDAMERIS BANK', id: 16 },
          { nombre: 'BANCO RIO', id: 19 },
          { nombre: 'BANCO BASA', id: 20 },
          { nombre: 'UENO', id: 26 },
          { nombre: 'BANCO DE LA NACION ARGENTINA', id: 30 },
          { nombre: 'TU FINANCIERA', id: 37 },
          { nombre: 'COOPERATIVA SAN CRISTOBAL', id: 38 },
          { nombre: 'COOMECIPAR', id: 39 },
          { nombre: 'COOPERATIVA MEDALLA MILAGROSA', id: 40 },
          { nombre: 'SOLAR', id: 41 },
          { nombre: 'COOPERATIVA UNIVERSITARIA', id: 42 },
        ]
      }

    }
  },
  methods: {
    tabClicked(id) {
      console.log(id)
    },
    setGeneracionId(gen) {
      this.selectedGeneracionId = gen
    },
    buscar(e) {

      if (this.busqueda === e.target.value.toUpperCase()) {
        return;
      }
      this.busqueda = e.target.value.toUpperCase();


      if (this.buscarTimer) {

        clearTimeout(this.buscarTimer);
      }

      this.buscarTimer = setTimeout(() => {
        if (this.busqueda && this.busqueda.length > 2) {

          if (isNaN(this.busqueda)) {
            this.filtrado = this.pendientes.filter(fila => {
              return fila.nombreTitular.toUpperCase().includes(this.busqueda);
            })
          } else {
            this.filtrado = this.pendientes.filter(fila => {
              return fila.ordenPagoId.toString().includes(this.busqueda) || fila.codMemSq.toString().includes(this.busqueda);
            })
          }

        } else {
          this.filtrado = this.pendientes;
        }

        this.buscarTimer = null;

      }, 500);



    },
    close() {
      this.$refs.form.reset();
      this.showDialog = false;
    },
    confirmar(detalle) {
      //detalle.ordenPagoId, detalle.monto, detalle.numeroCuenta, detalle.medioPagoId

      this.pendientes = this.pendientes.filter(r => r.ordenPagoId !== detalle.ordenPagoId);
      this.filtrado = this.pendientes;

      this.busqueda = '';
      this.showDialog = false;
      this.$emit("agregarDetalle", detalle);

    },

    async buscarMasivo() {


      this.busquedaMasivaRealizada = true;

      this.filtrado = await this.pendientes;

      //FILTRAMOS POR GENERACION
      this.filtrado = await this.filtrado.filter(p => p.generacionId === this.selectedGeneracionId);


      //QUE TENGA CUENTA BANCARIS
      this.filtrado = await this.filtrado.filter(p => p.numeroCuenta);


      //FILTRAMOS POR MEM_TYPE
      this.filtrado = await this.filtrado.filter(p => this.selectedMemType.includes(p.memType));

      //FILTRAMOS POR MONTO MAXIMO
      if (this.selectedMontoMaximo > 0) {
        this.filtrado = await this.filtrado.filter(p => p.monto <= this.selectedMontoMaximo);
      }

      //FILTRAMOS POR MONTO MINIMO
      if (this.selectedMontoMinimo > 0) {
        this.filtrado = await this.filtrado.filter(p => p.monto >= this.selectedMontoMinimo);
      }


      //FILTRAMOS POR BANCO
      // this.filtrado = await this.filtrado.filter(p => this.selectedMedioPago.includes(p.medioPagoId));
      const ids = this.selectedMedioPago.map(mp => mp.id);
      this.filtrado = await this.filtrado.filter(p => ids.includes(p.bancoId));


      // const r = regexParser(this.selectedMedioPago.str);

      // this.filtrado = await this.filtrado.filter(p => {
      //   if (p.formaCobro) {
      //     return p.formaCobro.search(new RegExp(r)) >= 0
      //   }
      //   return false
      // });



      //TODO: agregar boton de consulta y otro para confirmar, para que se visualize la cantidad de filas encontradas !!!!

      // this.$emit("agregarDetalleMasivo", this.filtrado);
      // this.showDialog = false;

    },
    async confirmarMasivo() {

      this.$emit("agregarDetalleMasivo", this.filtrado);
      this.showDialog = false;

    },
    volver() {
      this.busqueda = "";
      this.showDialog = false;
    },
    iniciar() {
      if (this.pendientes.length == 0) {
        this.actualizar();
      }
    },
    actualizar() {
      this.loading = true;

      this.busquedaMasivaRealizada = false;

      axios
        .get("/pago/pendientes")
        .then(response => {
          this.pendientes = response.data;
          this.filtrado = response.data;
          this.loading = false;
          // console.log(response.data);
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },

  },
  filters: {
    numberFormat(value) {
      if (value) {
        return numeral(+value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
  computed: {
    btnBuscarMasivo() {
      return this.selectedGeneracionId > 0 && this.selectedMemType.length > 0 && this.selectedMedioPago.length > 0;
    },
  }
});
</script>
<style scoped>
.blue {
  color: lightblue
}
</style>